import { MessageCircle } from "lucide-react";
import { motion } from "framer-motion";
import { WHATSAPP_URL } from "@/lib/constants";

export default function WhatsAppFloat() {
  return (
    <motion.a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      aria-label="Contattaci su WhatsApp"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.2, duration: 0.5, type: "spring" }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.95 }}
      className="fixed bottom-20 right-5 md:bottom-8 md:right-8 z-50 flex h-14 w-14 md:h-16 md:w-16 items-center justify-center rounded-full bg-green-500 text-white shadow-[0_0_25px_rgba(34,197,94,0.6)] hover:bg-green-400 hover:shadow-[0_0_40px_rgba(34,197,94,0.9)] transition-all"
    >
      {/* ping ring */}
      <span className="absolute inset-0 rounded-full bg-green-500 opacity-60 animate-ping" />
      <MessageCircle
        size={26}
        className="relative z-10"
        strokeWidth={2.4}
      />
    </motion.a>
  );
}
